import { specificObjective, activityGoals } from './messages'

export function activityGoalOrgLabel(org) {
  if (org.id === 7) {
    return specificObjective
  } else {
    return activityGoals
  }
}



// WEBPACK FOOTER //
// ./src/utils/orglabels.js